{
  "list": {
    "title": "الحوالات",
    "columns": {
      "number": "رقم الحوالة",
      "direction": "الاتجاه",
      "date": "التاريخ",
      "branch": "الفرع",
      "sender": "المرسل",
      "receiver": "المستلم",
      "amount": "مبلغ الحوالة",
      "commission": "العمولة",
      "net": "الصافي",
      "bankAccount": "الحساب البنكي",
      "box": "الصندوق",
      "employee": "الموظف",
      "status": "الحالة"
    },
    "pendingSync": "بانتظار المزامنة",
    "duplicateBadge": "مرجع مكرر",
    "filters": {
      "fromDate": "من تاريخ",
      "toDate": "إلى تاريخ",
      "branch": "الفرع",
      "employee": "الموظف",
      "box": "الصندوق",
      "bankAccount": "الحساب البنكي",
      "status": "الحالة",
      "direction": "الاتجاه"
    },
    "rowActions": {
      "trigger": "إجراءات الحوالة {{number}}",
      "viewDetails": "عرض التفاصيل",
      "continueDraft": "متابعة الحوالة"
    },
    "totals": {
      "label": "إجمالي الحوالات المسجلة ضمن الفلاتر الحالية",
      "count": "عدد الحوالات",
      "amount": "مبلغ الحوالة",
      "commission": "العمولة",
      "net": "الصافي"
    },
    "exportExcel": "تصدير إلى Excel",
    "exportPdf": "تصدير PDF",
    "exporting": "تصدير...",
    "customerNotPresent": "العميل غير موجود"
  },
  "states": {
    "DRAFT": "مبدئية",
    "POSTED": "مسجلة",
    "CANCELLED": "ملغاة"
  },
  "sync": {
    "PENDING": "بانتظار المزامنة",
    "SYNCED": "تمت المزامنة",
    "FAILED": "فشل الإرسال"
  },
  "direction": {
    "BANK_TO_CASH": "من بنك إلى نقد",
    "CASH_TO_BANK": "من نقد إلى بنك"
  },
  "commissionMode": {
    "DEDUCTED": "تخصم من المبلغ",
    "ADDED": "تضاف على المبلغ"
  },
  "details": {
    "back": "رجوع",
    "notFound": "الحوالة غير موجودة",
    "sections": {
      "identity": "بيانات الحوالة",
      "execution": "الفرع والتنفيذ",
      "amounts": "المبالغ",
      "parties": "الأطراف",
      "evidence": "الأدلة",
      "messages": "الرسائل",
      "prints": "الطباعة",
      "edits": "سجل التعديلات"
    },
    "fields": {
      "number": "رقم الحوالة",
      "date": "التاريخ",
      "status": "الحالة",
      "direction": "اتجاه الحوالة",
      "commissionMode": "طريقة احتساب العمولة",
      "notes": "ملاحظات",
      "cancelledFrom": "حالة الحوالة قبل الإلغاء",
      "cancelReason": "سبب الإلغاء",
      "cancelledBy": "ألغاها",
      "cancelledAt": "وقت الإلغاء",
      "branch": "الفرع",
      "box": "الصندوق",
      "bankAccount": "الحساب البنكي",
      "accountNumber": "رقم الحساب / IBAN",
      "createdBy": "أنشأها",
      "createdAt": "وقت الإنشاء",
      "postedBy": "اعتمدها",
      "postedAt": "وقت الاعتماد",
      "amount": "مبلغ الحوالة",
      "amountCashToBank": "المبلغ المستلم من العميل",
      "tier": "الشريحة",
      "tierRange": "من {{from}} إلى {{to}}",
      "noLimit": "بلا حد",
      "commission": "العمولة",
      "net": "صافي النقد",
      "netCashToBank": "المبلغ المحول",
      "receiver": "المستلم",
      "sender": "المرسل",
      "senderIsReceiverNote": "المرسل هو المستلم",
      "fullName": "الاسم الكامل",
      "phone": "الهاتف",
      "documentType": "نوع الوثيقة",
      "documentNumber": "رقم الوثيقة",
      "documentCountry": "دولة الإصدار",
      "documentConflict": "الوثيقة مسجلة لعميل آخر",
      "customerLink": "ملف العميل",
      "transferReference": "مرجع التحويل",
      "duplicateReference": "مرجع التحويل مستخدم في حوالة أخرى",
      "noReference": "بلا مرجع",
      "customerNotPresent": "العميل غير موجود"
    },
    "documentTypes": {
      "NATIONAL_ID": "هوية وطنية",
      "PASSPORT": "جواز سفر"
    },
    "signatures": {
      "title": "التوقيع",
      "signer": "اسم الموقع",
      "signedAt": "وقت التوقيع",
      "tablet": "الجهاز",
      "thisDevice": "هذا الجهاز",
      "language": "اللغة",
      "declaration": "نص الإقرار",
      "superseded": "وُقّع على نسخة سابقة",
      "image": "صورة التوقيع",
      "imageLoading": "جاري تحميل التوقيع...",
      "imageError": "تعذر تحميل التوقيع",
      "none": "لا يوجد توقيع"
    },
    "messages": {
      "none": "لا توجد رسائل",
      "templateLabel": "نوع الرسالة",
      "template": {
        "transfer_paid_recipient": "إشعار استلام الحوالة",
        "transfer_paid_sender": "نسخة للمرسل",
        "transfer_sent_sender": "إشعار إرسال الحوالة",
        "transfer_sent_recipient": "نسخة للمستلم"
      },
      "status": {
        "PENDING": "بانتظار الإرسال",
        "SENT": "تم الإرسال",
        "DELIVERED": "تم التسليم",
        "FAILED": "فشل الإرسال"
      },
      "phone": "الهاتف",
      "attempts": "عدد المحاولات",
      "sentAt": "وقت الإرسال",
      "deliveredAt": "وقت التسليم",
      "failureReason": "سبب الفشل"
    },
    "prints": {
      "none": "لا توجد عمليات طباعة",
      "first": "أول طباعة",
      "reprint": "إعادة طباعة",
      "by": "بواسطة",
      "at": "الوقت"
    },
    "edits": {
      "none": "لا توجد تعديلات",
      "sequence": "التعديل رقم {{sequence}}",
      "reason": "السبب",
      "by": "بواسطة",
      "field": "الحقل",
      "oldValue": "القيمة السابقة",
      "newValue": "القيمة الجديدة",
      "fields": {
        "amount": "مبلغ الحوالة",
        "commission": "العمولة",
        "net": "الصافي",
        "tier": "الشريحة",
        "box": "الصندوق",
        "bankAccount": "الحساب البنكي",
        "transferReference": "مرجع التحويل",
        "senderIsReceiver": "المرسل هو المستلم",
        "receiverFullName": "اسم المستلم الكامل",
        "receiverPhone": "هاتف المستلم",
        "receiverDocumentType": "نوع وثيقة المستلم",
        "receiverDocumentNumber": "رقم وثيقة المستلم",
        "receiverDocumentCountry": "دولة إصدار وثيقة المستلم",
        "senderFullName": "اسم المرسل الكامل",
        "senderPhone": "هاتف المرسل",
        "senderDocumentType": "نوع وثيقة المرسل",
        "senderDocumentNumber": "رقم وثيقة المرسل",
        "senderDocumentCountry": "دولة إصدار وثيقة المرسل",
        "notes": "ملاحظات"
      }
    },
    "actions": {
      "reprint": "إعادة طباعة",
      "resend": "إعادة الإرسال",
      "edit": "تعديل",
      "cancel": "إلغاء الحوالة"
    },
    "resend": {
      "confirmTitle": "تأكيد إعادة الإرسال",
      "confirmDescription": "سيتم إعادة إرسال رسائل الحوالة رقم {{number}}.",
      "success": "تم إعادة إرسال الرسائل بنجاح"
    }
  },
  "edit": {
    "drawerTitle": "تعديل الحوالة رقم {{number}}",
    "drawerDescription": "التعديل يتطلب سببا وينفذ فورا على حوالة مسجلة.",
    "fields": {
      "reason": "سبب التعديل",
      "amount": "مبلغ الحوالة",
      "amountAdded": "المبلغ المحول",
      "commissionModeHint": "طريقة احتساب العمولة: {{mode}}",
      "box": "الصندوق",
      "bankAccount": "الحساب البنكي",
      "transferReference": "مرجع التحويل",
      "senderIsReceiver": "المرسل هو المستلم",
      "notes": "ملاحظات",
      "branch": "الفرع"
    },
    "receiverSection": "بيانات المستلم",
    "senderSection": "بيانات المرسل",
    "preview": {
      "title": "تأكيد تعديل الحوالة",
      "description": "مراجعة التغييرات وأثرها على الأرصدة قبل الحفظ.",
      "changesTitle": "التغييرات",
      "effectsTitle": "الأثر على الأرصدة",
      "commission": "العمولة: {{before}} ← {{after}}",
      "net": "الصافي: {{before}} ← {{after}}",
      "tier": "الشريحة: {{before}} ← {{after}}",
      "supersedesSignature": "سيتحول التوقيع الحالي إلى \"وُقّع على نسخة سابقة\".",
      "duplicateReference": "مرجع التحويل مستخدم في حوالة أخرى",
      "confirm": "تأكيد",
      "back": "رجوع"
    },
    "updated": "تم تحديث الحوالة بنجاح"
  },
  "cancel": {
    "dialogTitle": "إلغاء الحوالة رقم {{number}}",
    "dialogDescription": "سيتم عكس أثر الحوالة على الصندوق والحساب البنكي مرة واحدة.",
    "fields": {
      "reason": "سبب الإلغاء"
    },
    "commit": "إلغاء الحوالة",
    "cancelled": "تم إلغاء الحوالة بنجاح"
  },
  "signature": {
    "label": "التوقيع",
    "clear": "مسح",
    "empty": "لم يتم التوقيع بعد"
  },
  "drafts": {
    "title": "الحوالات المبدئية",
    "description": "حوالات محفوظة لم تعتمد بعد. افتح الحوالة لإكمال بياناتها واعتمادها.",
    "empty": "لا توجد حوالات مبدئية",
    "continue": "متابعة الحوالة"
  }
}
